// import { contactBannerHTML } from '../global'

export function initStep2() {
    if ($('.id--16').length) {
        moveAddStep2Elements()
        // step2TextChanges()
        // addContactBanner()
    }
}

function moveAddStep2Elements() {}

function addContactBanner() {
    // $('#checkoutSidebar .cart-content').append(contactBannerHTML(true))
}

function step2TextChanges() {
    // $('.order-icon.order-delivery').text('test')
}
